/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Right_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Bottom right" |
*
* @param {Position_Bottom_Right_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_right_aria_label = /** @type {((inputs?: Position_Bottom_Right_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Right_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En bas a droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Внизу справа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abajo a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नीचे दाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canto inferior direito")
	return /** @type {LocalizedString} */ ("Bottom right")
});